import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class PdXjPointItemApi{

    static GET_URL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-xjpointitem/get";
    static UPDATE_URL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-xjpointitem/update";
    static INSERT_URL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-xjpointitem/insert";

    static get(params){
		return httpPost(PdXjPointItemApi.GET_URL,params);
    }

    static update(params){
		return httpPost(PdXjPointItemApi.UPDATE_URL,params);
    }

    static insert(params){
		return httpPost(PdXjPointItemApi.INSERT_URL,params);
    }

    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc){
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(errorFunc && typeof errorFunc == 'function'){
            errorFunc(response);
        }
    }
}